// extracted by mini-css-extract-plugin
module.exports = {"statsPage":"stylesheets_statsPage__12MjW"};